import stylesheet from './CardInCard.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

const ASPECT_RATIO_ATTRIBUTES = ['aspect-ratio', 'aspect-ratio-md', 'aspect-ratio-lg', 'aspect-ratio-xl', 'aspect-ratio-xxl'] as const;

class NXTCardInCard extends CustomComponent {
    static readonly observedAttributes = [...ASPECT_RATIO_ATTRIBUTES];

    private rootElement: HTMLElement;

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    get href(): string | null {
        return this.getAttribute('href');
    }

    get target(): string | null {
        return this.getAttribute('target');
    }

    setAspectRatioProperties(element: HTMLElement) {
        ASPECT_RATIO_ATTRIBUTES.forEach((attr) => {
            element.style.setProperty(`--${attr}`, this.getAttribute(attr) ?? null);
        });
    }

    render() {
        this.rootElement = document.createElement('div');
        this.rootElement.classList.add('card-in-card');
        this.setAspectRatioProperties(this.rootElement);

        this.rootElement.innerHTML = `
            <div class="background">
                <slot name="image"></slot>
                <div class="media-content">
                    <div class="overline"><slot name="overline"></slot></div>
                    <div class="image-title"><slot name="image-title"></slot></div>
                </div>
            </div>
        `;

        const innerCard = document.createElement(this.href ? 'a' : 'div');
        innerCard.classList.add('inner-card');

        if (this.href) {
            (innerCard as HTMLAnchorElement).href = this.href;
            if (this.target) {
                (innerCard as HTMLAnchorElement).target = this.target;
            }
        }

        innerCard.innerHTML = `
            <div class="title"><slot name="title"></slot></div>
            <div class="copy"><slot name="copy"></slot></div>
            <div class="footer"><slot name="footer"></slot></div>
        `;

        this.rootElement.appendChild(innerCard);

        this.setHasSlottedToParent(this.rootElement);
        return this.rootElement;
    }

    attributeChangedCallback() {
        if (this.rootElement) {
            this.setAspectRatioProperties(this.rootElement);
        }
    }
}

customElements.define('nxt-card-in-card', NXTCardInCard);
